/**
 * Calculates aspect ratio based on horizontal and vertical resolutions.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Number} args.horizontalResolution
 * @param {Number} args.verticalResolution
 * @return {Number}
 */

export default function calculateAspectRatio({ horizontalResolution, verticalResolution }) {
  return horizontalResolution / verticalResolution
}



// WEBPACK FOOTER //
// ./src/helpers/calculations/calculateAspectRatio.js